const EMAIL_LS_KEY = "ec_proof_email";

export const coerceBool = (value) =>
  value === true || value === "true" || value === 1;

export const isBadId = (id) =>
  id == null ||
  String(id).trim() === "" ||
  String(id).toLowerCase() === "undefined";

export const getProofDisplayFileName = (proof = {}) => {
  const explicitName = String(proof?.fileName || "").trim();
  if (explicitName) return explicitName;
  const filePath = String(proof?.filePath || proof?.proofFilePath || "").trim();
  if (!filePath) return "";
  const storedName = filePath.split(/[?#]/, 1)[0].split("/").pop() || "";
  try {
    return decodeURIComponent(storedName);
  } catch {
    return storedName;
  }
};

export const getProofReviewTitle = ({ proof = {}, product = {}, decoration = {}, labels = {} } = {}) => {
  const configuredItemName = String(labels?.itemName || "").trim();
  const productName = String(
    product?.Name || product?.name || (configuredItemName.toLowerCase() !== "item" ? configuredItemName : "")
  ).trim();
  const location = String(decoration?.Location || decoration?.location || "").trim();

  if (productName && location) return `${productName} • ${location}`;
  return productName || location || getProofDisplayFileName(proof) || "Proof";
};

export const normalizeRow = (raw) => {
  if (!raw) return null;

  const proofRaw = raw.proof || raw;
  const id = proofRaw?.id ?? proofRaw?.proofId ?? null;
  const filePath = proofRaw?.filePath ?? proofRaw?.proofFilePath ?? null;
  const hasFile = !!filePath;
  const statusRaw = String(proofRaw?.status || "").trim();
  const nextStatus = hasFile ? statusRaw : "Proof Needed";
  const hasContext = !!(raw.decoration || raw.product);

  if (isBadId(id) && !hasFile && !hasContext) {
    return null;
  }

  return {
    ...raw,
    proof: {
      ...proofRaw,
      id: String(id ?? ""),
      filePath,
      status: nextStatus,
      allProofsUploaded: coerceBool(proofRaw?.allProofsUploaded),
    },
  };
};

export const isRenderableRow = (row) =>
  !!row && !!row.proof && !isBadId(row.proof.id) && !!row.proof.filePath;

export const isPdfUrl = (value = "") => /\.pdf(?:$|[?#])/i.test(value);
export const isSvgUrl = (value = "") => /\.svg(?:$|[?#])/i.test(value);
export const isImageUrl = (value = "") =>
  /\.(?:png|jpe?g|gif|webp|bmp|tiff?|svg)(?:$|[?#])/i.test(value);
export const isVectorDocUrl = (value = "") => /\.(?:ai|eps)(?:$|[?#])/i.test(value);

export const extFromUrl = (url = "") => {
  try {
    const parsedUrl = new URL(url);
    const match = (parsedUrl.pathname || "").toLowerCase().match(/\.([a-z0-9]+)$/i);
    return match ? match[1] : "";
  } catch {
    const match = String(url).toLowerCase().match(/\.([a-z0-9]+)(?:\?|#|$)/i);
    return match ? match[1] : "";
  }
};

export const isImageExt = (ext = "") =>
  ["png", "jpg", "jpeg", "gif", "webp", "bmp", "svg"].includes(ext);

export const isPdfExt = (ext = "") => ext === "pdf";

export const isValidEmail = (value = "") =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());

export const getStoredEmail = () => {
  try {
    return localStorage.getItem(EMAIL_LS_KEY) || "";
  } catch {
    return "";
  }
};

export const setStoredEmail = (email) => {
  try {
    if (isValidEmail(email)) {
      localStorage.setItem(EMAIL_LS_KEY, String(email).trim());
    }
  } catch {}
};
